import { useState, useRef, Fragment } from "react";
import Config from "../../Config";


import back from "../../back.png";
import InputText from "../../helpers/InputText";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputCombo from "../../helpers/InputCombo";
import InputTextArea from "../../helpers/InputTextArea";
import InputComboGrupaE from "../../helpers/InputComboGrupaE";
import InputComboGrupy from "../../helpers/InputComboGrupy";
import InputSearchEmp from "../../helpers/InputSearchEmp";
import InputKidsMulti from "../../helpers/InputKidsMulti";

function BookNew(props)
{
       const [errTab, setErrTab] = useState([]);  //z info od serwera..
 

       const [row, setRowX] = useState({

            typ: props.typ,

            nazwa_wlasna:  "",
            rok_szkolny: "",

            xv_wydawnictwa_id: -1,
            poziom_klasa: "brak",
            krag_tematyczny: "brak",

            informacje_dodatkowe: "",

            status: "aktywny",
            kwalifikacja: "inne",

            nauczyciel_px_group_id: -1,


            p_grupa_id: -1,
            dzieci: [],

        
        });
        var tmpRow = row;





    const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

        const valChangeListener = (filedName, val, correct, msg) => {         
            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
            var tabCheck = filedName.split('@');
            if(tabCheck.length == 2)
            {
                var tabName = tabCheck[0];
                var tabInx  = tabCheck[1];
                var tRef = row[tabName];
                if(correct)tRef[tabInx] = val;
                if(!correct)tRef[tabInx] = "";

                tmpRow[tabName] = tRef;     
                setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  
    
                //setRowX( {...row, [tabName]:tRef } );   
                return;
            }
    
          
            tmpRow[filedName] = val;
            tmpRow[filedName+"_valid"] = correct;         
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
            //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
        }   
    

        const nGroupChange = (nName) =>{           
            
                console.log("Gr: " + nName);

                tmpRow["nazwa_wlasna"] = nName + " - Dziennik";
                tmpRow["nazwa_wlasna_valid"] = true;         
                setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  
           
        }

    
        const goNextNew = () => {
            console.log("goNext");
            saveData();
        }
    
        const saveData = () => {


 

            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        
    

    
            var req = row;

            if(req.nauczyciel_px_group_id.length > 0)
            {
                var nP = req.nauczyciel_px_group_id.split(" | ") ;
                if(nP.length == 2) 
                {
                    req.nauczyciel_px_group_id = nP[0];
                }
            }



            if(req.typ == 'grupa')
            {
                    if(req.p_grupa_id == -1 || req.p_grupa_id == '_x_')
                    {
                        props.mainView.showDialog( "Error", "Wybierz grupę" , "ok" , null);  
                        return;
                    }
            }

            if(req.typ == 'specjalistyczny' || req.typ == 'specjalisty')
            {
                    if(req.dzieci.length < 1)
                    {
                        props.mainView.showDialog( "Error", "Wybierz min. jedno dziecko" , "ok" , null);  
                        return;
                    }
            }


            props.mainView.setProgress(-2);
    
            fetch( Config.url + '/rest_v1_men,book_add', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            props.mainView.showDialog( "Sukces",  "Dziennik został dodany", "ok" , null);                         
                            props.onSuccess(res.result);
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }
     

       const onKidsSelected = (tab) => {
        setRowX( {...row, ["dzieci"]: tab  } );
        }


    const itemsKwalifikacja = [
        {v: "owwr",title: "Opinia - o Wczesnym Wspomaganiu Rozwoju"},
        {v: "oinna",title: "Opinia - inna"},
        {v: "orzecznie",title: "Orzeczenie z poradni"},
        {v: "inne",title: "Inny powód / Inny dla każdego dziecka"},
    ];    




     return (
                 <div className="view_content">

                        <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                        {
                            row.typ == "grupa" &&
                            <h3 className="calColor">Nowy dziennnik grupy</h3>
                        }

                        {
                            row.typ == "specjalistyczny" &&
                            <h3 className="calColor">Nowy dziennnik specjalistyczny</h3>
                        }

                        {
                            row.typ == "specjalisty" &&
                            <h3 className="calColor">Nowy dziennnik specjalisty</h3>
                        }

                                              
                        <form className="eForm bg_center">


                                            <div className="form_tab_title">Informacje ogólne:</div>

                                             <div className="form_tab">

                                                    {
                                                        row.typ == "grupa" &&
                                                        <Fragment>

                                                                <div className="form_control">
                                                                    <div className="fieldName">Grupa*</div>
                                                                    <InputComboGrupa  mainView={props.mainView} userData={props.userData} value={row.p_grupa_id} err={errTab}  valChange={valChangeListener} nChange={nGroupChange} goNext={goNextNew} name="p_grupa_id" placeholder={""} className=' w200 ' req='1' firstUp="1" />
                                                                </div>

                                                        </Fragment>
                                                    }

                                                    

                                                    <div className="form_split"></div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Nazwa własna dziennika*</div>
                                                        <InputText   userData={props.userData} value={row.nazwa_wlasna} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa_wlasna" placeholder={"Dziennik - Smerfiki"} className=' w300 ' req='1' firstUp="0" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Rok szkolny (np. 2024/2025)*</div>
                                                        <InputText   userData={props.userData} value={row.rok_szkolny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rok_szkolny" placeholder={""} className=' w150 ' req='1' firstUp="0" />
                                                    </div>



                                                    {
                                                        (row.typ == "specjalistyczny" || row.typ == "specjalisty") &&
                                                        <Fragment>

                                                                <div className="form_split"></div>

                                                                <div className="form_control">
                                                                    <div className="fieldName">Podstawa*</div>
                                                                    <InputCombo items={itemsKwalifikacja}  mainView={props.mainView} userData={props.userData} value={row.kwalifikacja} err={errTab}  valChange={valChangeListener} nChange={nGroupChange} goNext={goNextNew} name="kwalifikacja" placeholder={""} className='  ' req='1' firstUp="1" />
                                                                </div>

                                                                <div className="form_control">
                                                                    <div className="fieldName">Informacje dodatkowe</div>
                                                                    <InputTextArea   userData={props.userData} value={row.informacje_dodatkowe} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="informacje_dodatkowe" placeholder={""} className=' w300 h50 ' req='0' firstUp="0" />
                                                                </div>


                                                               

                                                                <div className="form_control">
                                                                    <div className="fieldName">Imię i nazwisko osoby prawadzącej / nauczyciel*</div>
                                                                    <InputSearchEmp  mainView={props.mainView} userData={props.userData} value={row.nauczyciel_px_group_id} err={errTab}  valChange={valChangeListener} nChange={nGroupChange} goNext={goNextNew} name="nauczyciel_px_group_id" placeholder={""} className='  ' req='1' firstUp="1" />
                                                                </div>


                                                        </Fragment>
                                                    }


                                             </div>


                                            {
                                                (row.typ == "specjalistyczny" || row.typ == "specjalisty") &&
                                                <Fragment>                                                         
                                                        <div className="form_tab">
                                                             

                                                                <div className="form_tab_title">Dzieci ujęte w dzienniku, wybierz min. jedno dziecko</div>
                                                                <div className="form_tab">               
                                                                            <InputKidsMulti   userData={props.userData}  mainView={props.mainView} onKidsSelected={onKidsSelected}   />  
                                                                </div>


                                                        </div>


                                                </Fragment>
                                            }


                                             
                                            <div className="form_split"></div>
                                                <br/>
                                            <div className="form_split"></div>

                                            <div className="form_btn">
                                                    <div className="btn" onClick={saveData}>dalej</div>
                                                    &nbsp;&nbsp;
                                                    <div className="btn" onClick={props.onBack}    > anuluj</div>
                                            </div>
                                             



                        </form>


                </div>
    )
}


export default BookNew;